// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D2-z","displaySixCardTiles":"E2-z"};